import React from 'react'
import classes from './Modal.module.scss'
import Close from '@mui/icons-material/Close'
import { ItineraryFerry } from '../../../atom/Types'
import { CloseButtonSvg, DateSvg, FerrySvg, LocationSvg } from '../../../constants/resources';
import moment from 'moment';
import { Time, checkSpacing } from '../../../atom/utilities/function';

interface props {
    ferryDetails: ItineraryFerry[];
    handleFerry: (n: ItineraryFerry[], m: string) => void
    activeferry: ItineraryFerry | {}
    setActiveFerry: React.Dispatch<React.SetStateAction<{} | ItineraryFerry>>
    buliddata: any
}

const FerryModal: React.FC<props> = ({ ferryDetails, handleFerry, activeferry, setActiveFerry, buliddata }) => {
    const handleSelection = (ferry: ItineraryFerry) => {
        if ('id' in activeferry && ferry.id === activeferry.id)
            setActiveFerry({})
        else
            setActiveFerry(ferry)
    }
    return (
        <div className={classes.ModalBackground}>
            <div className={classes.scrollModalContent}>
                <div className={classes.Flex}>
                    <div className={classes.modalTop}>
                        <div className={classes.header}>Select a ferry</div>
                        <div className={classes.flightTop}>
                            <button className={classes.CloseButton} onClick={() => handleFerry(ferryDetails, 'close')}>
                                <Close className={classes.closesvg} />
                            </button>
                        </div>
                    </div>
                    <hr />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', }}>
                    <div className={classes.carScrollContainer}>

                        {ferryDetails?.map((ferry, index) => {
                            return <div key={index} className={'id' in activeferry && ferry.id === activeferry?.id ? classes.mainViewSelected : classes.mainView}>
                                <div className={classes.displayView}>
                                    <div className={classes.carContainer}>
                                        <div className={classes.carHead}>
                                            <div>{ferry?.ferry.ferryCompany}</div>
                                        </div>
                                        {ferry?.name !== "" ? <div style={{ display: "flex", flexDirection: 'row', gap: '6px' }}>
                                            <div>
                                                <FerrySvg />
                                            </div>
                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <div className={classes.carDetails}>Ferry trip name</div>
                                                <div>{ferry?.name}</div>
                                            </div>
                                        </div> : null}
                                        <div style={{ display: "flex", flexDirection: 'row', gap: '6px' }}>
                                            <div>
                                                <DateSvg />
                                            </div>
                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <div className={classes.carDetails}>Departure date</div>
                                                <div style={{ width: "272px", fontSize: '16px' }}>{moment.utc(ferry?.departDate).format('MMM DD')} at {Time(ferry?.departTime)}</div>
                                            </div>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: 'row', gap: '6px' }}>
                                            <div>
                                                <DateSvg />
                                            </div>
                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <div className={classes.carDetails}>Arrival date</div>
                                                <div style={{ width: "272px", fontSize: '16px' }}>{moment.utc(ferry?.arrivalDate).format('MMM DD')} at {Time(ferry?.arrivalTime)}</div>
                                            </div>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: 'row', gap: '6px' }}>
                                            <div>
                                                <LocationSvg width={"13px"} height={"12px"} />

                                            </div>
                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <div className={classes.carDetails}>Departure port</div>
                                                <div style={{ width: "272px", fontSize: '16px' }}>{ferry?.ferry?.departurePort}</div>
                                            </div>
                                        </div>

                                        <div style={{ display: "flex", flexDirection: 'row', gap: '6px' }}>
                                            <div>
                                                <LocationSvg width={"13px"} height={"12px"} />

                                            </div>
                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <div className={classes.carDetails}>Arrival port</div>
                                                <div style={{ width: "272px", fontSize: '16px' }}>{ferry?.ferry?.arrivalPort}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={classes.carPrice}>
                                        <p className={classes.price}>{ferry?.price !== null && ferry?.price !== 0 ? `$ ${ferry?.price}` : null}</p>
                                        {ferry.comment && <p style={{ textAlign: "left" }} dangerouslySetInnerHTML={{ __html: checkSpacing(ferry?.comment) ? ferry?.comment : "" }}></p>}
                                        <p style={{ fontSize: '14px', color: '#FF3566' }}>{ferry?.cancellationPolicy}</p>
                                    </div>
                                </div>
                                {buliddata.type === 'Proposal' && <div style={{ display: 'flex', justifyContent: 'center' }}><button className={'id' in activeferry && ferry?.id === activeferry?.id ? classes.subButtonSelected : classes.subButton} onClick={() => handleSelection(ferry)}>{'id' in activeferry && ferry?.id === activeferry?.id ? <span>
                                    <CloseButtonSvg />
                                    Clear Choice</span> : "Choose"}</button></div>}
                            </div>
                        })}
                    </div>
                </div>
                {buliddata.type === 'Proposal' ? <div className={classes.carButton}><button disabled={Object.keys(activeferry).length > 0 ? false : true} onClick={() => handleFerry(ferryDetails, 'choose')}>Confirm</button></div>
                    :
                    ferryDetails[0]?.selected ?
                        <div className={classes.ClearChoice}>
                            <button onClick={() => { handleFerry(ferryDetails, 'choose') }}>
                                <Close style={{ marginRight: "8px", color: "#FF3566", transform: "scale(0.8)" }} />
                                Clear choice
                            </button>
                        </div> :
                        <div className={classes.Choose}>
                            <button onClick={() => handleFerry(ferryDetails, 'choose')}>
                                Choose
                            </button>
                        </div>
                }

            </div>
        </div>
    )
}

export default FerryModal